import { PrivacyStatementComponent } from './privacy-statement.component';

export { PrivacyStatementComponent };
